<section class="diag_area">
    <div class="diag_flex">
        <div class="column_one">
            <div class="colone_banner">
                <div class="logo_ctr">
                    <figure class="mb-0">
                        <img src="assets/img/diagnostic/ilwhite.png" alt="logo" class="dia_logo">
                    </figure>
                </div>
                <div class="colone_maintxt">
                    <p class="dia_mntxt">Take the test & identify your strengths & <br> weaknesses to upgrade your
                        learning</p>
                    <figure class="mb-0">
                        <img src="assets/img/diagnostic/diarohit.png" alt="rohit" class="diarohit">
                        <img src="assets/img/diagnostic/mobdiarohit.png" alt="rohit" class="mobdiarohit">
                    </figure>
                </div>
            </div>
            <div class="dia_termsbg">
                <p class="dia_rules"><a class="dia_terms">Terms & Conditions </a> | <a class="dia_terms"> Privacy
                        Policy</a></p>
            </div>
        </div>
        <div class="column_two">
            <div class="col-md-12 col-lg-12 col-12">
                <div>
                    <div class="coltwo_cntr">
                        <figure class="mb-0">
                            <img src="assets/img/diagnostic/ilwhite.png" alt="logo" class="mob_dia_logo">
                            <img src="assets/img/diagnostic/thankyou.png" alt="congrats" class="dia_thankimg">
                        </figure>
                        <h6 class="dia_thankhd">Thank You for registration with us!!</h6>
                        <p class="dia_clsschdle">Your test schedule</p>
                        <h6 class="dia_timeschedle">{{PaymentstatusUtility.completedDetails?.scoreRegisterDetails | date:'d MMM, Y, hh:mm a'}}</h6>
                        <p class="dia_clsschdle">Please visit our centre to take the test till <strong> 31th August</strong>.</p>
                        <h6 class="dia_perform">Get <strong>1 on 1</strong> guidance basis your performance.</h6>
                    </div>
                    <div class="coltwo_form">
                        <div class="row">
                            <div class="col-md-12">
                                <button type="button" class="diag_genotp" (click)="login()" >Login</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>